import {
    Typography,
    Button,
    Radio,
    Tooltip,
    Tag,
    Checkbox,
    Popover,
    Descriptions,
    Skeleton,
    Divider,
    Card,
    Avatar
} from 'antd';
import React from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import {
    FileTextOutlined,
    PushpinOutlined,
    FileImageOutlined
} from '@ant-design/icons';
import { RelativePath } from './GlobalParams';
import { result } from 'lodash';
import Meta from 'antd/lib/card/Meta';
import { dataService } from './dataService';

const { Text } = Typography;
const listRef = React.createRef();

class DataTable extends React.Component {
    state = {
        showUnmarked: true,
        showPopoverId: null,
        itemDetails: {}
    };

    handleVisibleChange = async (visible, id) => {
        if (visible) {
            this.setState({ showPopoverId: id, itemDetails: 'Loading...' });
            this.props.setSelectedHighlightId(id);
            let result = await dataService.firestore
                .collection('docMarkers')
                .doc(id)
                .get();
            this.setState({ itemDetails: result.data() });
        }
    };

    render() {
        let totalCount = this.props.dataSource.length;
        let dataSource = this.state.showUnmarked
            ? this.props.dataSource
            : this.props.dataSource.filter((m) => m.position.pageNumber > -1);

        let unmarkedCount = this.props.dataSource.length - dataSource.length;

        const getContents = (value) => {
            let item = this.state.itemDetails;
            let image =
                (value.content ? value.content.image : null) ||
                (item.content ? item.content.image : null);
            return (
                <div
                    onClick={() => {
                        this.setState({ showPopoverId: null });
                    }}
                >
                    <Card
                        hoverable
                        style={{ width: 240 }}
                        cover={
                            <div style={{ textAlign: 'center' }}>
                                <Skeleton loading={item.id == null} active>
                                    {image ? (
                                        <img
                                            width="150px"
                                            height="150px"
                                            style={{ objectFit: 'scale-down' }}
                                            alt="Not marked"
                                            src={image}
                                        />
                                    ) : (
                                        <span>
                                            <Avatar
                                                size="large"
                                                icon={<FileImageOutlined />}
                                            />
                                            <br />
                                            Not Marked
                                        </span>
                                    )}
                                </Skeleton>
                            </div>
                        }
                    >
                        <Skeleton loading={item.id == null} active>
                            <Typography>
                                <Text strong>Equipment Code: </Text>
                                <br />
                                <Text>{item.eqNo}</Text>
                                <br />
                                <Text strong>Equipment Name: </Text>
                                <br />
                                <Text>{item.eqName}</Text>
                                <br />
                                <Text strong>Spare Parts Description: </Text>
                                <br />
                                <Text>{item.itemDesc}</Text>
                                <br />
                                <Text strong>Part Number: </Text>
                                <br />
                                <Text>{item.partNo}</Text>
                                <br />
                                <Text strong>Plate/Drawing No.: </Text>
                                <br />
                                <Text>{item.plateNo}</Text>
                                <br />
                                <Text strong>Specification: </Text>
                                <br />
                                <Text>{item.itemSpec}</Text>
                                <br />
                                <Text strong>Position Number: </Text>
                                <br />
                                <Text>{item.positionNo}</Text>
                                <br />
                            </Typography>
                        </Skeleton>
                    </Card>
                    {/*  */}
                </div>
            );
        };

        const Row = ({ index, style }) => {
            var item = dataSource[index];
            var isSelected = item.id == this.props.selectedHighlightId;
            var rowClassName = index % 2 ? 'ListItemOdd' : 'ListItemEven';
            rowClassName += isSelected ? ' ListSelected' : '';
            var pageNo =
                item.position.pageNumber <= 0
                    ? item.importPageNo
                    : item.position.pageNumber;
            return (
                <Popover
                    visible={this.state.showPopoverId == item.id}
                    content={getContents(item)}
                    placement="left"
                    trigger="contextMenu"
                    onVisibleChange={(visible) =>
                        this.handleVisibleChange(visible, item.id)
                    }
                >
                    <div
                        className={rowClassName}
                        style={style}
                        onClick={(e) => {
                            this.props.setSelectedHighlightId(item.id);
                            this.setState({ showPopoverId: null });
                        }}
                    >
                        <span className="ListItemCell" style={{ width: '5%' }}>
                            <Radio checked={isSelected}></Radio>
                        </span>
                        <span
                            className="ListItemCell"
                            style={{ width: '20%' }}
                            title={
                                item.partNo == null || item.partNo == ''
                                    ? 'Position No ' + item.positionNo
                                    : 'Part No ' + item.partNo
                            }
                        >
                            <Text
                                ellipsis
                                mark={item.partNo == null || item.partNo == ''}
                            >
                                {item.partNo == null || item.partNo == ''
                                    ? item.positionNo
                                    : item.partNo}
                            </Text>
                        </span>
                        <span
                            className="ListItemCell"
                            style={{ width: '50%' }}
                            title={item.itemDesc}
                        >
                            <Text ellipsis>{item.itemDesc}</Text>
                        </span>
                        <span className="ListItemCell" style={{ width: '15%' }}>
                            <Text ellipsis>{pageNo}</Text>
                        </span>
                        <span className="ListItemCell" style={{ width: '10%' }}>
                            <Tooltip>
                                {item.position.pageNumber > -1 ? (
                                    <PushpinOutlined />
                                ) : null}
                            </Tooltip>
                        </span>
                    </div>
                </Popover>
            );
        };

        return (
            <div
                style={{
                    padding: '1vh',
                    height: '100%'
                }}
            >
                <div
                    style={{
                        height: '5%'
                    }}
                >
                    <div className="ListItemOdd" style={{ height: '100%' }}>
                        <span className="ListItemOdd" style={{ width: '70%' }}>
                            Showing {dataSource.length} of {totalCount} items
                        </span>
                        <span className="ListItemOdd" style={{ width: '30%' }}>
                            <Checkbox
                                onChange={(c) => {
                                    this.setState({
                                        showUnmarked: !this.state.showUnmarked
                                    });
                                }}
                            >
                                Marked <PushpinOutlined />
                            </Checkbox>
                        </span>
                    </div>
                </div>
                <div
                    style={{
                        height: '5%'
                    }}
                >
                    <div className="ListItemEven" style={{ height: '100%' }}>
                        <span
                            className="ListItemCell"
                            style={{ width: '5%' }}
                        ></span>
                        <span className="ListItemCell" style={{ width: '20%' }}>
                            #
                        </span>
                        <span className="ListItemCell" style={{ width: '50%' }}>
                            Description
                        </span>
                        <span className="ListItemCell" style={{ width: '15%' }}>
                            PageNo
                        </span>
                        <span
                            className="ListItemCell"
                            style={{ width: '10%' }}
                        ></span>
                    </div>
                </div>
                <div
                    style={{
                        height: '90%'
                    }}
                >
                    <AutoSizer>
                        {({ height, width }) => (
                            <List
                                ref={listRef}
                                className="List"
                                height={height}
                                itemCount={dataSource.length}
                                itemSize={35}
                                width={width}
                            >
                                {Row}
                            </List>
                        )}
                    </AutoSizer>
                </div>
            </div>
        );
    }

    componentDidMount() {
        let AppInstance = this;
        window.addEventListener(
            'hashchange',
            () => {
                if (
                    document.getElementsByClassName('ListSelected').length < 1
                ) {
                    let id = location.hash.slice('#highlight-'.length);

                    let dataSource = this.props.dataSource.filter((m) => {
                        return (
                            this.state.showUnmarked ||
                            m.position.pageNumber > -1
                        );
                    });
                    let index = dataSource.findIndex((f) => f.id == id);
                    listRef.current.scrollToItem(index);
                }
            },
            false
        );
    }
}

export default DataTable;



// WEBPACK FOOTER //
// ./demo/src/DataTable.js